/**
 * Switch active states on mouseenter and keep customers box highlighted on mouseleave
 */
jQuery(function($){
    // switch active states
    $('.home .site2-anchors__topic').mouseenter(function(){
        $('.site2-anchors__topic').removeClass('active');
        $(this).addClass('active');
    });
    // keep customers box highlighted on mouseleave
    $('.home .site2-anchors').mouseleave(function(){
        $('.site2-anchors__topic').removeClass('active');
        $('.site2-anchors__topic:first-child').addClass('active');
    });
});
